import authModule from "../../../../../utilities/AuthModule";
import { ComponentTypes } from "../../../config/config";
import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { BaseFolderPanelHelper } from "./BaseFolderPanelHelper";
import { IFolderPanelHelper } from "../../../interfaces/IFolderPanelHelper";


export class TeamMainFolderPanelHelper extends BaseFolderPanelHelper implements IFolderPanelHelper {
    constructor(
        folderPanelInfo: IFolderPanelInfo,
        currentDirectory: IPageSettings) {
        super(folderPanelInfo, currentDirectory);
    }

    async getFolderFinalLocation(): Promise<IPageSettings> {
        return {
            id: this.folderPanelInfo.folder.id,
            type: ComponentTypes.SharePointDocuments,
            siteId: this.folderPanelInfo.folder.siteId,
            siteDisplayName: this.folderPanelInfo.folder.name,
            webUrl: this.folderPanelInfo.webUrl,
            directory: "",
            DocumentLibrary: "",
            teamGroupId: this.folderPanelInfo.folder.id,
            displayName: this.folderPanelInfo.folder.name,
            isSharedTeam: this.folderPanelInfo.folder.isSharedTeam
        };
    }

    async save() {

    }
}
